import type { Feature } from './types';

const title = 'OpenGPU Provider';

const config: Feature<{ api: { endpoint: string; basePath: string } }> =
  (() => {
    return Object.freeze({
      title,
      isEnabled: true,
      api: {
        endpoint: 'https://management-backend.opengpu.network/api/',
        basePath: 'https://management-backend.opengpu.network/api/',
      },
    });
  })();

export default config;
